// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { DateRangeAttributes } from 'common/widgets/date-range-picker/models/date-range';
import { DisplayContext } from 'common/widgets/date-range-picker/models/types';
import { TrackingUsageContext } from 'common/report/tracking-setup';
import { DateRangePresetBarEl } from './index';

// Header date selector shim that chooses between rendering the new prototype and the old <mp-query-block>
export function headerDateSelectorRenderer(_ref: {
  displayContext: DisplayContext;
  selectedDateRange: null | Partial<DateRangeAttributes>;
  projectAsOfDate: string;
  maxHistoryDays: number;
  disableDatePickerMessage?: string;
  disableSubDayGranularityMessage?: string;
  handleApply: (ev) => void;
  handleRemove?: () => void;
}) {
  let {
    displayContext,
    selectedDateRange,
    projectAsOfDate,
    maxHistoryDays,
    disableDatePickerMessage,
    disableSubDayGranularityMessage,
    handleApply,
    handleRemove = null
  }: {
    displayContext: DisplayContext;
    selectedDateRange: null | Partial<DateRangeAttributes>;
    projectAsOfDate: string;
    maxHistoryDays: number;
    disableDatePickerMessage?: string;
    disableSubDayGranularityMessage?: string;
    handleApply: (ev) => void;
    handleRemove?: () => void;
  } = _ref;
  return <DateRangePresetBarEl attrs={{
    'display-context': displayContext,
    'date-range': selectedDateRange !== null && selectedDateRange !== void 0 ? selectedDateRange : null,
    'project-as-of-date': projectAsOfDate,
    'max-history-days': maxHistoryDays,
    'tracked-use-case': TrackingUsageContext.Report,
    'can-clear': !!handleRemove,
    'disable-date-picker-message': disableDatePickerMessage,
    'disable-sub-day-granularity-message': disableSubDayGranularityMessage,
    elref: "dateRangePresetBar"
  }} on={{
    apply: handleApply,
    clear: handleRemove
  }} data-sentry-element="DateRangePresetBarEl" data-sentry-component="headerDateSelectorRenderer" data-sentry-source-file="header-date-selector.tsx" />;
}